import { c as _c } from "react/compiler-runtime";
import { useBulkActionsMode } from "@hooks/use-bulk-actions-mode";
import { getBulkActionButtonConfig } from "@components/common/faro-table/bulk-actions/bulk-actions-config";
import { FaroTextButton } from "@components/common/faro-text-button";
import { Text, ExportIcon } from "@flat-ui";
/**
 * Export button styled for bulk actions (export all data).
 * Displays a download icon followed by the label text.
 */
export function BulkExportButton(t0) {
  const $ = _c(15);
  const {
    isOpen,
    onClick,
    label,
    buttonTooltipText
  } = t0;
  const mode = useBulkActionsMode();
  let t1;
  if ($[0] !== buttonTooltipText || $[1] !== mode) {
    t1 = getBulkActionButtonConfig(mode, buttonTooltipText);
    $[0] = buttonTooltipText;
    $[1] = mode;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const config = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ExportIcon sx={{
      height: 18,
      width: 18
    }} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== config.shouldShowText || $[5] !== label) {
    t3 = config.shouldShowText && <Text variant="buttonM">{label}</Text>;
    $[4] = config.shouldShowText;
    $[5] = label;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== config.loadingTrackColor || $[8] !== config.rippleColor || $[9] !== config.sx || $[10] !== config.tooltipText || $[11] !== isOpen || $[12] !== onClick || $[13] !== t3) {
    t4 = <FaroTextButton onClick={onClick} tooltipText={config.tooltipText} loadingTrackColor={config.loadingTrackColor} startIcon={t2} rippleColor={config.rippleColor} sx={config.sx} aria-haspopup="listbox" aria-expanded={isOpen}>{t3}</FaroTextButton>;
    $[7] = config.loadingTrackColor;
    $[8] = config.rippleColor;
    $[9] = config.sx;
    $[10] = config.tooltipText;
    $[11] = isOpen;
    $[12] = onClick;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}